import { graphql } from "@/lib/gql/__generated__/gql";

export const HOTEL_NOTIFICATION_SETTING_MUTATION = graphql(/* GraphQL */ `
	mutation HotelNotificationSettingMutation($input: HotelNotificationSettingInput!) {
		hotelNotificationSettingUpdate(input: $input) {
			hotelNotificationSetting {
				ecNotificationEmails
				paymentNotificationEmails
				reservationNotificationEmails
				hotelID
				id
			}
			userErrors
		}
	}
`);
